var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeCommentActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 11.6667H18.6666H12.38C11.6666 11.6667 11.06 12.1133 10.92 12.74L10.0266 16.74C9.84663 17.5667 10.5466 18.3333 11.4866 18.3333H14.3066L13.2933 21.6267C13.08 22.3133 13.64 23 14.4133 23C14.8 23 15.1733 22.84 15.4266 22.5667L19.3333 18.3333H22V11.6667H19.3333ZM14.9333 22.1133C14.8066 22.2533 14.6133 22.3333 14.4133 22.3333C14.24 22.3333 14.08 22.26 13.9933 22.1333C13.9466 22.0667 13.8933 21.96 13.9333 21.82L14.9466 18.5267L15.2133 17.6667H14.3066H11.4866C11.2133 17.6667 10.9533 17.5533 10.8 17.36C10.72 17.26 10.6333 17.0933 10.68 16.88L11.5733 12.88C11.64 12.5667 11.98 12.3333 12.38 12.3333H18.6666V18.0733L14.9333 22.1133ZM21.3333 17.6667H19.3333V12.3333H21.3333V17.6667Z",
    fill: "blue"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeCommentActive);
export default __webpack_public_path__ + "static/media/dislike-comment-active.3c0fb807e9dd68a30040cc9fc4f26b3d.svg";
export { ForwardRef as ReactComponent };